/* PRA Watch · Accesorio obligatorio (aro adaptador del VH31) (Grok Bot).
   - Al añadir el VH31 al carrito (ficha, compra rápida, configurador o cualquier
     llamada a /cart/add), añade el aro adaptador en la MISMA petición.
   - En el carrito, si se intenta quitar o bajar el aro por debajo del número de VH31,
     se mantiene la cantidad necesaria y se avisa; si sube el VH31, sube el aro.
   - Al cargar cualquier página y antes de ir al checkout, comprueba el carrito y
     repone el aro si faltara.
   La configuración (IDs y precio) la escribe snippets/pra-mandatory-addon.liquid. */
(function (root) {
  'use strict';

  /* ---------------- LÓGICA PURA (testeable con node) ---------------- */
  function num(x) { var n = Number(x); return isFinite(n) ? n : 0; }
  function sameId(a, b) { return String(a) === String(b); }
  function isMain(rule, id) { return rule.variantIds.some(function (v) { return sameId(v, id); }); }
  function isAddon(rule, id) { return sameId(rule.addonVariantId, id); }

  /* Cantidades de principal/accesorio en una lista de líneas [{id|variant_id, quantity}] */
  function countIn(rule, lines) {
    var m = 0, a = 0;
    (lines || []).forEach(function (l) {
      var id = l.variant_id != null ? l.variant_id : l.id, q = num(l.quantity == null ? 1 : l.quantity);
      if (isMain(rule, id)) m += q; else if (isAddon(rule, id)) a += q;
    });
    return { main: m, addon: a };
  }

  /* Líneas a añadir a una petición /cart/add para cumplir las reglas.
     reqItems: líneas de la petición; cartItems: líneas actuales del carrito (o null si se desconoce) */
  function addonsForAdd(rules, reqItems, cartItems) {
    var extra = [];
    (rules || []).forEach(function (r) {
      var req = countIn(r, reqItems);
      if (!req.main) return;
      var cart = cartItems ? countIn(r, cartItems) : { main: 0, addon: 0 };
      var need = (cart.main + req.main) - (cart.addon + req.addon);
      if (need > 0) {
        var props = {}; props[r.propertyName || '_Obligatorio'] = r.code;
        extra.push({ id: num(r.addonVariantId), quantity: need, properties: props });
      }
    });
    return extra;
  }

  /* Faltantes en un carrito completo: [{ rule, missing }] */
  function deficits(rules, cartItems) {
    var out = [];
    (rules || []).forEach(function (r) {
      var c = countIn(r, cartItems);
      if (c.main > c.addon) out.push({ rule: r, missing: c.main - c.addon });
    });
    return out;
  }

  /* Interpreta el cuerpo de una petición /cart/add (FormData, URLSearchParams, JSON o texto urlencoded)
     y devuelve { items: [...], extra: {sections, sections_url, ...} } o null si no se reconoce. */
  function entriesOf(body) {
    var list = [];
    if (typeof FormData !== 'undefined' && body instanceof FormData) { body.forEach(function (v, k) { list.push([k, v]); }); return list; }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) { body.forEach(function (v, k) { list.push([k, v]); }); return list; }
    if (typeof body === 'string' && body.trim().charAt(0) !== '{') {
      body.split('&').forEach(function (kv) {
        if (!kv) return; var i = kv.indexOf('=');
        var k = decodeURIComponent((i < 0 ? kv : kv.slice(0, i)).replace(/\+/g, ' '));
        var v = i < 0 ? '' : decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' '));
        list.push([k, v]);
      });
      return list;
    }
    return null;
  }

  function parseAddBody(body) {
    if (body == null) return null;
    if (typeof body === 'string' && body.trim().charAt(0) === '{') {
      var j; try { j = JSON.parse(body); } catch (e) { return null; }
      var extra = {}; Object.keys(j).forEach(function (k) { if (k !== 'items' && k !== 'id' && k !== 'quantity' && k !== 'properties' && k !== 'selling_plan') extra[k] = j[k]; });
      if (Array.isArray(j.items)) return { items: j.items.map(function (x) { return Object.assign({}, x); }), extra: extra };
      if (j.id != null) { var it = { id: j.id, quantity: j.quantity == null ? 1 : num(j.quantity) }; if (j.properties) it.properties = j.properties; if (j.selling_plan) it.selling_plan = j.selling_plan; return { items: [it], extra: extra }; }
      return null;
    }
    var entries = entriesOf(body); if (!entries) return null;
    var single = { properties: {} }, indexed = {}, extra2 = {}, hasSingle = false, hasIdx = false;
    entries.forEach(function (e) {
      var k = e[0], v = e[1], m;
      if (typeof v !== 'string') return; // ficheros: no se tocan
      if (k === 'id') { single.id = v; hasSingle = true; }
      else if (k === 'quantity') single.quantity = num(v);
      else if (k === 'selling_plan') single.selling_plan = v;
      else if ((m = k.match(/^properties\[(.+)\]$/))) single.properties[m[1]] = v;
      else if ((m = k.match(/^items\[(\d*)\]\[(id|quantity|selling_plan)\]$/))) { hasIdx = true; var ix = m[1] || String(Object.keys(indexed).length); indexed[ix] = indexed[ix] || { properties: {} }; indexed[ix][m[2]] = m[2] === 'quantity' ? num(v) : v; }
      else if ((m = k.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/))) { hasIdx = true; indexed[m[1]] = indexed[m[1]] || { properties: {} }; indexed[m[1]].properties[m[2]] = v; }
      else if (k === 'sections') extra2.sections = extra2.sections ? extra2.sections + ',' + v : v;
      else if (k === 'sections_url') extra2.sections_url = v;
    });
    var items = [];
    if (hasSingle) { if (single.quantity == null) single.quantity = 1; items.push(single); }
    if (hasIdx) Object.keys(indexed).sort(function (a, b) { return a - b; }).forEach(function (k) { var it = indexed[k]; if (it.quantity == null) it.quantity = 1; items.push(it); });
    if (!items.length) return null;
    items.forEach(function (it) { if (it.properties && !Object.keys(it.properties).length) delete it.properties; it.id = num(it.id); });
    return { items: items, extra: extra2 };
  }

  function buildJsonBody(parsed, extraItems) {
    var o = {}; Object.keys(parsed.extra || {}).forEach(function (k) { o[k] = parsed.extra[k]; });
    o.items = parsed.items.concat(extraItems || []);
    return JSON.stringify(o);
  }

  function cartPath(url, origin) {
    var u; try { u = new URL(String(url), origin || 'https://x.invalid'); } catch (e) { return null; }
    if (origin && u.origin !== new URL(origin).origin) return null;
    var m = u.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js|\.json)?$/);
    return m ? m[1] : null;
  }

  /* Decide cómo reescribir un /cart/change. cart: carrito actual; body: objeto JSON de la petición.
     Devuelve { kind: 'none' } | { kind: 'change', body, notice } | { kind: 'update', url, body, notice } */
  function planChange(rules, cart, body) {
    if (!cart || !body) return { kind: 'none' };
    var items = cart.items || [], target = null, idx = -1;
    if (body.line != null) { idx = num(body.line) - 1; target = items[idx]; }
    else if (body.id != null) {
      for (var i = 0; i < items.length; i++) if (String(items[i].key) === String(body.id) || sameId(items[i].variant_id, body.id) || sameId(items[i].id, body.id)) { target = items[i]; idx = i; break; }
    }
    if (!target || body.quantity == null) return { kind: 'none' };
    var newQ = num(body.quantity);
    for (var r = 0; r < rules.length; r++) {
      var rule = rules[r];
      var after = items.map(function (l, i) { return { variant_id: l.variant_id, quantity: i === idx ? newQ : l.quantity }; });
      var c = countIn(rule, after);
      if (c.main <= c.addon) continue;
      if (isAddon(rule, target.variant_id)) {
        // quitar/bajar el aro: se deja la cantidad mínima
        var keep = target.quantity - (c.addon - c.main) + (c.main - c.addon) ; // = cantidad para igualar
        keep = newQ + (c.main - c.addon);
        var nb = Object.assign({}, body, { quantity: keep });
        return { kind: 'change', body: nb, notice: 'remove' };
      }
      if (isMain(rule, target.variant_id)) {
        // sube el VH31: se sube también el aro en la misma petición (cart/update)
        var updates = {};
        updates[target.key] = newQ;
        var addonLines = items.filter(function (l) { return isAddon(rule, l.variant_id); });
        var missing = c.main - c.addon;
        if (addonLines.length) updates[addonLines[0].key] = addonLines[0].quantity + missing;
        else updates[String(rule.addonVariantId)] = missing;
        var ub = { updates: updates };
        ['sections', 'sections_url'].forEach(function (k) { if (body[k] != null) ub[k] = body[k]; });
        return { kind: 'update', body: ub, notice: 'raise' };
      }
    }
    return { kind: 'none' };
  }

  var logic = { countIn: countIn, addonsForAdd: addonsForAdd, deficits: deficits, parseAddBody: parseAddBody, buildJsonBody: buildJsonBody, cartPath: cartPath, planChange: planChange };
  if (typeof module !== 'undefined' && module.exports) module.exports = logic;
  if (root) root.PRAMandatoryAddonLogic = logic;
  if (typeof document === 'undefined' || !root || !root.fetch) return;

  /* ---------------- NAVEGADOR ---------------- */
  var cfgEl = document.getElementById('pra-addon-rules');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var rules = (CFG.rules || []).filter(function (r) { return r && r.addonVariantId && r.variantIds && r.variantIds.length; });
  if (!rules.length || root.__praAddonInstalled) return;
  root.__praAddonInstalled = true;

  var origFetch = root.fetch.bind(root);
  var routes = CFG.routes || {};
  var root_url = (routes.root || '/').replace(/\/$/, '');
  var fmt; try { fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: CFG.currency || 'EUR' }); } catch (e) { fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } }; }
  function money(c) { return fmt.format(num(c) / 100); }

  function getCart() {
    return origFetch(root_url + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function headersWithJson(h) {
    var out = {};
    if (h) {
      if (typeof Headers !== 'undefined' && h instanceof Headers) h.forEach(function (v, k) { out[k] = v; });
      else Object.keys(h).forEach(function (k) { out[k] = h[k]; });
    }
    Object.keys(out).forEach(function (k) { if (k.toLowerCase() === 'content-type' || k.toLowerCase() === 'accept') delete out[k]; });
    out['Content-Type'] = 'application/json'; out.Accept = 'application/json';
    if (!Object.keys(out).some(function (k) { return k.toLowerCase() === 'x-requested-with'; })) out['X-Requested-With'] = 'XMLHttpRequest';
    return out;
  }

  /* Aviso visible */
  var toastTimer;
  function notice(text) {
    var el = document.getElementById('pra-addon-toast');
    if (!el) {
      el = document.createElement('div'); el.id = 'pra-addon-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = text; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 7000);
  }
  function addonLabel(r) { return 'Incluye ' + (r.addonLabel || 'aro adaptador') + ' obligatorio (+' + money(r.addonPrice) + ')'; }

  /* Interceptor de fetch */
  root.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' || input instanceof URL ? String(input) : (input && input.url);
      var kind = url ? cartPath(url, location.origin) : null;
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (!kind || method !== 'POST' || !init || init.__praSkip) return origFetch(input, init);
      if (kind === 'add') return handleAdd(input, init);
      if (kind === 'change') return handleChange(input, init);
      if (kind === 'update' || kind === 'clear') return origFetch(input, init).then(function (res) { setTimeout(reconcile, 50); return res; });
    } catch (e) { /* ante cualquier duda, petición original */ }
    return origFetch(input, init);
  };

  function handleAdd(input, init) {
    var parsed = parseAddBody(init.body);
    if (!parsed) return origFetch(input, init);
    var req = parsed.items;
    if (!rules.some(function (r) { return countIn(r, req).main > 0; })) return origFetch(input, init);
    return getCart().catch(function () { return null; }).then(function (cart) {
      var extra = addonsForAdd(rules, req, cart && cart.items);
      if (!extra.length) return origFetch(input, init);
      var body = buildJsonBody(parsed, extra);
      var init2 = Object.assign({}, init, { body: body, headers: headersWithJson(init.headers) });
      return origFetch(input, init2).then(function (res) {
        if (res.ok) { var r0 = rules[0]; notice('Hemos añadido el ' + (r0.addonLabel || 'aro adaptador') + ' obligatorio para el ' + r0.code + ' (+' + money(r0.addonPrice) + ').'); }
        return res;
      });
    });
  }

  function handleChange(input, init) {
    var body = null;
    if (typeof init.body === 'string') { try { body = JSON.parse(init.body); } catch (e) { body = null; } }
    else { var en = entriesOf(init.body); if (en) { body = {}; en.forEach(function (e) { body[e[0]] = e[1]; }); } }
    if (!body) return origFetch(input, init).then(function (res) { setTimeout(reconcile, 50); return res; });
    return getCart().catch(function () { return null; }).then(function (cart) {
      var plan = planChange(rules, cart, body);
      if (plan.kind === 'change') {
        notice('El ' + (rules[0].addonLabel || 'aro adaptador') + ' es obligatorio con el movimiento ' + rules[0].code + '. Para quitarlo, quita antes el ' + rules[0].code + '.');
        return origFetch(input, Object.assign({}, init, { body: JSON.stringify(plan.body), headers: headersWithJson(init.headers) }));
      }
      if (plan.kind === 'update') {
        return origFetch(root_url + '/cart/update.js', Object.assign({}, init, { body: JSON.stringify(plan.body), headers: headersWithJson(init.headers) })).then(function (res) {
          if (res.ok) notice('Hemos ajustado el ' + (rules[0].addonLabel || 'aro adaptador') + ' obligatorio: uno por cada ' + rules[0].code + '.');
          return res;
        });
      }
      return origFetch(input, init);
    });
  }

  /* Reposición de seguridad (carga de página, actualizaciones externas, antes del checkout) */
  var busy = false;
  function reconcile(opts) {
    if (busy) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      var d = deficits(rules, cart.items);
      if (!d.length) return false;
      var items = d.map(function (x) { var p = {}; p[x.rule.propertyName || '_Obligatorio'] = x.rule.code; return { id: num(x.rule.addonVariantId), quantity: x.missing, properties: p }; });
      return origFetch(root_url + '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: headersWithJson(), body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'error'); return true; }); })
        .then(function () {
          notice('Hemos vuelto a añadir el ' + (d[0].rule.addonLabel || 'aro adaptador') + ' obligatorio para el ' + d[0].rule.code + '.');
          if (!(opts && opts.noReload)) {
            var k = 'praAddonReload', n = num(sessionStorage.getItem(k));
            if (n < 2) { sessionStorage.setItem(k, String(n + 1)); setTimeout(function () { location.reload(); }, 900); }
          }
          return true;
        });
    }).catch(function () {
      notice('Atención: el ' + rules[0].code + ' necesita el ' + (rules[0].addonLabel || 'aro adaptador') + ' obligatorio. Añádelo al carrito antes de pagar.');
      return false;
    }).then(function (x) { busy = false; return x; }, function () { busy = false; return false; });
  }

  /* Antes de ir al checkout */
  function goingToCheckout(e) {
    var t = e.target && e.target.closest ? e.target.closest('[name="checkout"], a[href*="/checkout"], form[action*="/checkout"] [type="submit"]') : null;
    if (e.type === 'submit') {
      var f = e.target; if (!(f && f.action && /\/(checkout|cart)(\?|$)/.test(f.action))) return;
      var sub = e.submitter; if (!/\/checkout/.test(f.action) && !(sub && sub.name === 'checkout')) return;
      t = f;
    }
    if (!t || t.__praOk) return;
    e.preventDefault(); e.stopPropagation();
    reconcile({ noReload: true }).then(function () { location.href = root_url + '/checkout'; });
  }
  document.addEventListener('click', goingToCheckout, true);
  document.addEventListener('submit', goingToCheckout, true);

  /* Nota visible junto al botón de compra del VH31 (ficha, compra rápida, tarjetas) */
  function decorate(scope) {
    rules.forEach(function (r) {
      if (!r.productId) return;
      var sel = 'product-form-component[data-product-id="' + r.productId + '"]';
      Array.prototype.forEach.call((scope || document).querySelectorAll(sel), function (pfc) {
        if (pfc.querySelector('.pra-addon-note')) return;
        var p = document.createElement('p'); p.className = 'pra-addon-note'; p.textContent = addonLabel(r);
        var form = pfc.querySelector('form') || pfc; form.appendChild(p);
      });
    });
  }
  function boot() {
    decorate(document);
    try { new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { decorate(document); break; } }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    if (sessionStorage.getItem('praAddonReload')) setTimeout(function () { sessionStorage.removeItem('praAddonReload'); }, 5000);
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})(typeof window !== 'undefined' ? window : null);